import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement } from 'chart.js';
ChartJS.register(Tooltip, Legend);

interface PieChartProps {
  
  data: Array<{
    label: string;
    value: number;
    backgroundColor: string;
  }>;
  options?: any;
  height?: number;
  utilizationData?: any;
  total_capacity?: number;
  utilized_capacity?: number;
  non_utilized_capacity?: number;
}


export const PieChart: React.FC<PieChartProps> = ({ total_capacity, utilized_capacity, non_utilized_capacity, height=320 }) => {
  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement);
  
  const options = {
    type: 'doughnut',
    radius: 100, // Adjust the radius value to control the size of the donut
    cutout: '80%', 
    responsive: true,
    maintainAspectRatio: false as const,
    layout: { padding: { top: 16, right: 12, bottom: 8, left: 12 } },
    plugins: {
      legend: { position: 'top' as const },
      tooltip: {
        callbacks: {   
        },
      },
    },

    
  };

  const data = {
    
    labels: ["Total Capacity", "Utilized", "Non Utilized"],
    datasets: [{
      data: [total_capacity, utilized_capacity, non_utilized_capacity],
      backgroundColor: ['#4e73df', '#427261ff', '#cc4a36ff'],
      hoverBackgroundColor: ['#2e59d9', '#17a673', '#2c9faf'],
      hoverBorderColor: "rgba(234, 236, 244, 1)",
      
    }],
  };
  return (
    <div className="chart-bar" style={{ height, minWidth: 0 }} >
        <Pie height={height} data={data} options={options}/>
        
    </div>
);
};

export default PieChart;